<mat-toolbar class="custom-toolbar">
  <mat-toolbar-row>

    <a id="logo" title="Train optimizer">
      <img src="../../assets/TO_Logo_final_quer_WEISS_72dpi.png" class="logo">
    </a>
    <div class="link-wrapper" *ngIf="!authService?.isLoggedIn()">
      <a href="https://www.trainoptimizer.eu" target="_blank" title="trainoptimizer.com" class="wrapper">
        <span class="optimizer-text">TrainOptimizer Webpage</span>
        <span class="icon-position">
          <mat-icon class="icon">forward</mat-icon>
        </span>
      </a>
    </div>
    <div class="toolbaritems" *ngIf="authService?.isLoggedIn()">
      <div class="toolbaritems-main">
        <div class="toolbaritem" *ngIf="authService?.getCurrentRoleId() === 1">
          <!-- Company Section -->
          <button mat-button class="color" [ngClass]="{active: isActive('company')}" [routerLink]="['/company/list']">
            {{companyNav.title}}
          </button>
        </div>
        <div class="toolbaritem" *ngIf="authService?.getCurrentRoleId() === 1 || authService?.getCurrentRoleId() === 2">
          <!-- User Section -->
          <button mat-button class="color" [ngClass]="{active: isActive('user')}" [routerLink]="['/user/list']">
            {{userNav.title}}
          </button>
        </div>
        <div class="toolbaritem" *ngIf="authService?.getCurrentRoleId() ===2 || authService?.getCurrentRoleId() === 3">
          <!-- Project Section -->
          <button mat-button class="color" [ngClass]="{active: isActive('project')}" [routerLink]="['/project/list']">
            {{projectNav.title}}
          </button>
        </div>
        <div class="toolbaritem" *ngIf="authService?.getCurrentRoleId() === 2 || authService?.getCurrentRoleId() === 3">
          <!-- Evaluation Section -->
          <button mat-button class="color" [ngClass]="{active: isActive('evaluation')}"
            [routerLink]="['/evaluation/selection']">{{evaluationNav.title}}</button>
        </div>
        <div class="toolbaritem" *ngIf="authService?.getCurrentRoleId() === 1">
          <button mat-button class="color" [ngClass]="{active: isActive('datamanagement')}"
            [routerLink]="['/datamanagement/list']">{{datamanagementNav.title}}</button>
        </div>
        <div class="toolbaritem" *ngIf="false">
          <!-- Test Section -->
          <button mat-button [routerLink]="">Test</button>
        </div>
        <div class="toolbaritem" *ngIf="false">
          <!-- Test Section -->
          <button mat-button [routerLink]="">Test</button>
        </div>
        <span class="example-fill-remaining-space"></span>
      </div>
      <div class="toolbaritem-user">
        <button class="color" mat-button [matMenuTriggerFor]="logedUserMenu">
          {{authService?.getCurrentEmail()}} {{userMenuNav.suffix}}
        </button>
        <mat-menu #logedUserMenu="matMenu" [overlapTrigger]="false">
          <button mat-menu-item (click)="userSettings()">
            <mat-icon>settings</mat-icon>{{userMenuNav.settings}}
          </button>
          <button mat-menu-item (click)="authService?.logout()">
            <mat-icon>exit_to_app</mat-icon>{{userMenuNav.logOut}}
          </button>
        </mat-menu>
      </div>
    </div>
  </mat-toolbar-row>
</mat-toolbar>